import React, { Dispatch, SetStateAction } from 'react';
import { FormProvider } from 'react-hook-form';
import { useLongTermWorkflow } from './useLongTermWorkflow';
import { StepContainer } from '../StepContainer/StepContainer';
import { AutomatedAccountsDTO } from '../../api/useAutomatedAccountsQuery';
import { useResetModuleWrapperStyles } from '../../../../_hooks/useResetModuleWrapperStyles';
import { FinancialGoal } from '../../AutoAccountWorkflow.types';

interface LongTermWorkflowProps {
  restartWizard: Dispatch<SetStateAction<void>>;
  onSuccess: Dispatch<SetStateAction<void>>;
  data: AutomatedAccountsDTO;
  initialActiveWorkflow: FinancialGoal | null;
}

export const LongTermWorkflow: React.FC<LongTermWorkflowProps> = ({
  restartWizard,
  onSuccess,
  data,
  initialActiveWorkflow,
}) => {
  const {
    data: { CurrentStep, ...restData },
    actions: { formBag, ...restActions },
  } = useLongTermWorkflow({ onSuccess, data });

  useResetModuleWrapperStyles();

  return (
    <StepContainer
      restartWizard={restartWizard}
      initialActiveWorkflow={initialActiveWorkflow}
      {...restData}
      {...restActions}
    >
      <FormProvider {...formBag}>
        <CurrentStep onNext={() => restActions.nextStep()} data={data} />
      </FormProvider>
    </StepContainer>
  );
};
